import script from "./filter-tabs.vue?vue&type=script&lang=tsx"
export * from "./filter-tabs.vue?vue&type=script&lang=tsx"

const __exports__ = script;

export default __exports__